import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderTrustedMarkdown } from '~/functions/markdown';
import { useVentureId } from '~/functions/accounts';
import { useGetImpactGoalQuery, useGetSectionWithQuestionsQuery, TemplateEngineContext } from '~/types/types';
import { IMPACT_SECTION_IDS } from '~/constants/impactSectionIds';
import { IMPACT_STRATEGY_CONCEPT_ID } from '~/constants/concepts';
import { canEditImpact, useRealUserIsIxAdmin } from '~/functions/impact-locking';
export default /*#__PURE__*/_defineComponent({
  __name: 'theoryOfChange',
  setup: function setup(__props) {
    var SECTION_ID = IMPACT_SECTION_IDS.strategyTheoryOfChange;
    var ventureId = useVentureId();
    var _useGetImpactGoalQuer = useGetImpactGoalQuery({
        ventureId: ventureId.value
      }),
      result = _useGetImpactGoalQuer.result;
    var impactGoal = computed(function () {
      var _result$value;
      return ((_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.getImpactGoal) || {};
    });
    var tocImpact = computed(function () {
      var _impactGoal$value, _impactGoal$value$imp;
      return (_impactGoal$value = impactGoal.value) === null || _impactGoal$value === void 0 ? void 0 : (_impactGoal$value$imp = _impactGoal$value.impacts) === null || _impactGoal$value$imp === void 0 ? void 0 : _impactGoal$value$imp.find(function (e) {
        return e.conceptId === IMPACT_STRATEGY_CONCEPT_ID;
      });
    });
    var realUserIsIxAdmin = useRealUserIsIxAdmin();
    var tocImpactEditable = computed(function () {
      return canEditImpact(tocImpact.value, realUserIsIxAdmin.value);
    });
    var showGuidance = ref(false);
    var _useGetSectionWithQue = useGetSectionWithQuestionsQuery(computed(function () {
        return {
          id: SECTION_ID
        };
      }), computed(function () {
        return {
          enabled: true
        };
      })),
      sectionResult = _useGetSectionWithQue.result,
      getSectionLoading = _useGetSectionWithQue.loading;
    var section = computed(function () {
      var _sectionResult$value;
      return ((_sectionResult$value = sectionResult.value) === null || _sectionResult$value === void 0 ? void 0 : _sectionResult$value.getSection) || null;
    });
    return {
      __sfc: true,
      SECTION_ID: SECTION_ID,
      ventureId: ventureId,
      result: result,
      impactGoal: impactGoal,
      tocImpact: tocImpact,
      realUserIsIxAdmin: realUserIsIxAdmin,
      tocImpactEditable: tocImpactEditable,
      showGuidance: showGuidance,
      sectionResult: sectionResult,
      getSectionLoading: getSectionLoading,
      section: section,
      renderTrustedMarkdown: renderTrustedMarkdown,
      TemplateEngineContext: TemplateEngineContext
    };
  }
});